















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { IClient } from '@/api/types-client'
import { sortByNumber, sortByString } from '@/utils/sort'

@Component({
  name: 'ClientsTable'
})
export default class extends Vue {
  @Prop({
    type: Array,
    required: true,
    default: () => {
      return []
    }
  })
  list!: Array<IClient>;

  @Prop({ type: Number }) total = 0;

  @Prop({ type: Boolean }) listLoading = true;

  sortClientId(a: IClient, b: IClient): number {
    return sortByNumber(a.clientId, b.clientId)
  }

  sortName(a: IClient, b: IClient): number {
    return sortByString(a.name, b.name)
  }

  sortCompany(a: IClient, b: IClient): number {
    return sortByString(a.company, b.company)
  }

  sortPhone(a: IClient, b: IClient): number {
    return sortByString(a.phone, b.phone)
  }

  private handleDelete(clientId: number) {
    this.$confirm('Confirm to deactivate this Client?', 'Warning', {
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      type: 'warning'
    })
      .then(async() => {
        this.$emit('handleDelete', clientId)
      })
      .catch(err => { console.error(err) })
  }
}
